<template>
  <div>
    <div v-if="calls.length" class="d-flex flex-wrap">
      <div v-for="call in calls" :key="call.id">
        <tooltip :disabled="!isAlreadyLinked(call.id)" placement="top">
          <template #trigger>
            <Button
              class="mr-2 mt-2"
              :disabled="isAlreadyLinked(call.id)"
              @click="$emit('link-call', call.id)"
            >
              <i class="fa-solid fa-link-horizontal mr-1"></i>
              <span>{{ call.caller.name }}</span>
              <span>{{ call.caller.phone_number }}</span>
            </Button>
          </template>
          <template #tooltip> Already Linked to Call History </template>
        </tooltip>
      </div>
    </div>
    <div v-else>
      <span>No Active Sessions to link to this source.</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Button from "@/components/Button.vue";
import Tooltip from "@/components/Tooltip.vue";
export default {
  components: {
    Button,
    Tooltip
  },
  props: {
    linkedCalls: {
      type: Array,
      default: () => []
    }
  },
  emits: ["link-call"],
  computed: {
    ...mapGetters(["activeCalls"]),
    calls() {
      return this.activeCalls;
    }
  },
  methods: {
    isAlreadyLinked(callId) {
      return this.linkedCalls.some((call) => call.id === callId);
    }
  }
};
</script>

<style lang="scss" scoped>
.fa-hands-clapping {
  color: var(--secondary-color);
  font-size: 2.6em;
}
</style>
